(function () {
  'use strict';

  function init() {
    var pathParts = window.location.pathname.split('/');
    var productsIdx = pathParts.indexOf('products');
    if (productsIdx === -1) return;
    var handle = pathParts[productsIdx + 1];
    if (!handle) return;

    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) { setupForProduct(product); })
      .catch(function () {});
  }

  function setupForProduct(product) {
    var variants = product.variants;
    if (!variants || variants.length <= 1) return;

    function qty(title) {
      var m = (title || '').match(/^(\d+)/);
      return m ? parseInt(m[1], 10) : null;
    }

    var allQty = variants.every(function (v) { return qty(v.title) !== null; });
    if (!allQty) return;

    var sorted = variants.slice().sort(function (a, b) {
      return (qty(a.title) || 999) - (qty(b.title) || 999);
    });
    var base = sorted[0];
    var unitPrice = base.price / (qty(base.title) || 1);

    var comp = document.querySelector('[id^="variant-selects-"], [id^="variant-radios-"]');
    if (!comp) return;
    var sectionId = comp.id
      .replace('variant-selects-', '')
      .replace('variant-radios-', '');

    var priceEl = document.getElementById('price-' + sectionId);
    if (!priceEl) return;

    var SAVINGS_ID = 'bb-savings-' + sectionId;
    var STYLE = 'display:none;color:#2d7d32;font-size:1.8rem;font-weight:600;margin:6px 0 0;padding:0;line-height:1.2;';
    var currentVariantId = null;

    function getOrInsert() {
      var el = document.getElementById(SAVINGS_ID);
      if (el) return el;
      var pc = priceEl.querySelector('.price__container') || priceEl;
      var newEl = document.createElement('p');
      newEl.id = SAVINGS_ID;
      newEl.className = 'bb-savings';
      newEl.setAttribute('aria-live', 'polite');
      newEl.style.cssText = STYLE;
      pc.appendChild(newEl);
      return newEl;
    }

    function render(variantId) {
      currentVariantId = variantId;
      var el = getOrInsert();
      var v = variants.find(function (x) { return String(x.id) === String(variantId); });
      if (!v) { el.style.display = 'none'; return; }
      var q = qty(v.title);
      var baseQty = qty(base.title) || 1;
      if (!q || q <= baseQty) { el.style.display = 'none'; return; }
      var saved = Math.round(unitPrice * q) - v.price;
      if (saved > 0) {
        el.textContent = 'Spara ' + Math.round(saved / 100) + ' kr jämfört med styckpris';
        el.style.display = 'block';
      } else {
        el.style.display = 'none';
      }
    }

    // MutationObserver: re-insert after Dawn re-renders the price block
    var observer = new MutationObserver(function () {
      if (!document.getElementById(SAVINGS_ID) && currentVariantId !== null) {
        render(currentVariantId);
      }
    });
    observer.observe(priceEl, { childList: true, subtree: true });

    // Initial render
    var initScript = comp.querySelector('script[data-selected-variant]');
    if (initScript) {
      try { render(JSON.parse(initScript.textContent).id); } catch (e) {}
    } else {
      var inp = document.querySelector('input[form^="product-form-"][name="id"]');
      if (inp) render(inp.value);
    }

    // Dawn pubsub — fires before re-render; re-render will trigger observer above
    if (typeof subscribe === 'function') {
      subscribe('variant-change', function (data) {
        var variant = data && data.data && data.data.variant;
        var sid = data && data.data && data.data.sectionId;
        if (variant && (!sid || sid === sectionId)) {
          currentVariantId = variant.id;
        }
      });
    }

    // Fallback change listener
    comp.addEventListener('change', function () {
      setTimeout(function () {
        var inp = document.querySelector('input[form^="product-form-"][name="id"]');
        if (inp) render(inp.value);
      }, 80);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
